module.exports = __webpack_public_path__ + "static/media/pitch-mock-6.0cb43117.png";